<template>
  <b-modal id="modal-content-facebook" size="lg" hide-footer>
    <!-- custom modal content -->
    <template #modal-title>
      <div class="d-flex align-items-center">
        <feather-icon size="20" icon="InfoIcon" class="mr-05" />
        <span class="fs-18">Detail Postingan</span>
      </div>
    </template>
    <div v-if="data" class="row mb-2">
      <div class="col-md-12">
        <p class="fs-16 font-weight-bolder text-justify">{{ data.title }}</p>
        <div class="d-flex">
          <span class="mr-2 fs-14 d-flex align-items-center">
            <feather-icon icon="FacebookIcon" class="text-success mr-05" />
            {{ data.account }}
          </span>
          <span class="mr-2 fs-14 d-flex align-items-center">
            <feather-icon icon="CalendarIcon" class="text-dark mr-05" />
            {{ parseDate(data.date) }}
          </span>
          <span class="fs-14 d-flex align-items-center">
            <feather-icon icon="ClockIcon" class="text-dark mr-05" />
            {{ parseDate(data.created_at) }}
          </span>
        </div>
        <div class="scroller mt-2" style="max-height: 25rem;">
          <p
            class="text-justify"
            v-html="data.content"
          ></p>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { BModal, VBModal } from "bootstrap-vue";
import helper from "@/helper/helper.js";
import { data } from "jquery";

export default {
  name: "contentModal",
  components: {
    BModal,
  },
  props: {
    data: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  methods: {
    parseDate(date) {
      return helper.dateParser(date);
    },
  },
  directives: {
    "b-modal": VBModal,
  },
};
</script>